import forEach from "lodash/forEach";
import filter from "lodash/filter";
import { NODE_GROUP_MIN_SIZE } from "Areas/Documents/graph/constants";
import GroupNodesSource from "Areas/Documents/graph/types/groupNodesSource";
import addOrUpdateGroupNodesLabel from "Areas/Documents/graph/utils/nodeRendering/addOrUpdateGroupNodesLabel";
export default function createGroupNodes({ graphComponentRef, graph, jsonGraphModel, nodeMap, documentObjects, groups, nodesSource }) {
    if (!jsonGraphModel.DataGroups)
        return;
    forEach(jsonGraphModel.DataGroups, groupData => {
        var _a, _b, _c, _d;
        if (nodeMap.has(groupData.Id)) {
            console.warn(`Узел группы уже существует: ${groupData.Id}. Пропуск создания.`);
            return;
        }
        const groupMeta = groups === null || groups === void 0 ? void 0 : groups[groupData.Id];
        const nodesInGroup = filter(nodesSource, node => Boolean(node.GroupId === groupData.Id && node.PinnedToGroup));
        try {
            if (nodesInGroup.length > 0) {
                const groupNode = graph.createGroupNode({
                    layout: {
                        x: (_a = groupData.X) !== null && _a !== void 0 ? _a : 0,
                        y: (_b = groupData.Y) !== null && _b !== void 0 ? _b : 0,
                        width: (_c = groupData.Width) !== null && _c !== void 0 ? _c : NODE_GROUP_MIN_SIZE.width,
                        height: (_d = groupData.Height) !== null && _d !== void 0 ? _d : NODE_GROUP_MIN_SIZE.height
                    },
                    tag: new GroupNodesSource(groupData.Id, nodesInGroup, documentObjects, groupData.Width || NODE_GROUP_MIN_SIZE.width, groupData.Height || NODE_GROUP_MIN_SIZE.height, groupData.Name || (groupMeta === null || groupMeta === void 0 ? void 0 : groupMeta.Name), nodesInGroup.length)
                });
                graph.setIsGroupNode(groupNode, true);
                addOrUpdateGroupNodesLabel(graphComponentRef, groupNode);
                nodeMap.set(groupData.Id, groupNode);
            }
        }
        catch (ex) {
            console.error(`Не удалось создать узел группы: ${groupData.Id}`, ex);
        }
    });
}
